import { call, put, takeEvery } from "redux-saga/effects";

// Redux action types
import { GET_HISTORY_LIST_ACCOUNTANT } from "./actionTypes";

// Action creators
import {
  getActivitylogAccountantSuccess,
  getActivitylogAccountantFail,
} from "./actions";

// Helper API call
import { getActivitylogAccountant } from "../../helpers/django_api_helper";

function* fetchActivityLogAccountant(action) {
  try {
    const { id } = action.payload;
    console.log("[Saga] Fetching Accountant Activity Log for User ID:", id);

    const response = yield call(getActivitylogAccountant, id);

    console.log("[Saga] API Response received:", response);

    yield put(getActivitylogAccountantSuccess(response));
  } catch (error) {
    console.error("[Saga] Error fetching Accountant Activity Log:", error);
    yield put(getActivitylogAccountantFail(error));
  }
}

function* AccountantHistorySaga() {
  yield takeEvery(GET_HISTORY_LIST_ACCOUNTANT, fetchActivityLogAccountant);
}

export default AccountantHistorySaga;
